import React, { Fragment, useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "./App.scss";
import { PublicLayout, PrivateLayout } from "../../layout";

import {
  HomeScreen,
  AboutScreen,
  StudentsScreen,
  LoginScreen,
  LoginSchoolScreen,
  RegistrationScreen,
  ClassesScreen,
  TeachersScreen,
  StaffScreen,
  SettingsScreen,
  SplashScreen,
  ErrorScreen,
  ForgotPasswordScreen,
  PeriodScreen,
} from "../../screens";
import { useDispatch, useSelector } from "react-redux";
import { selectLoggedIn } from "../../store/slices/auth/slice";
import { fetchUserInfo } from "../../store/slices/user/asyncThunks";

function App() {
  const [minimumDurationPassed, setMinimumDurationPassed] = useState(false);
  const dispatch = useDispatch();

  const isAuthenticated = useSelector(selectLoggedIn);

  useEffect(() => {
    dispatch(fetchUserInfo());
  }, [dispatch]);

  useEffect(() => {
    const timer = setTimeout(() => setMinimumDurationPassed(true), 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Fragment>
      {isAuthenticated !== null && minimumDurationPassed ? (
        <div className="app" style={{ height: "100%" }}>
          <ToastContainer
            newestOnTop={true}
            autoClose={3500}
            position={toast.POSITION.TOP_RIGHT}
          />
          <Routes>
            <Route element={<PrivateLayout />}>
              <Route path="/" element={<HomeScreen />} />
              <Route path="/classes" element={<ClassesScreen />} />
              <Route path="/classes/period" element={<PeriodScreen />} />
              <Route path="/classes/period/:id" element={<PeriodScreen />} />
              <Route path="/teachers" element={<TeachersScreen />} />
              <Route path="/students" element={<StudentsScreen />} />
              <Route path="/staff" element={<StaffScreen />} />
              <Route path="/settings" element={<SettingsScreen />} />
            </Route>
            <Route element={<PublicLayout />}>
              <Route path="/login" element={<LoginScreen />} />
              <Route path="/login-school" element={<LoginSchoolScreen />} />
              <Route path="/registration" element={<RegistrationScreen />} />
              <Route
                path="/forgot-password"
                element={<ForgotPasswordScreen />}
              />
              <Route path="/about" element={<AboutScreen />} />
            </Route>
            <Route path="*" element={<ErrorScreen />} />
          </Routes>
        </div>
      ) : (
        <SplashScreen />
      )}
    </Fragment>
  );
}

export default App;
